import { render } from "./edit_approve.vue?vue&type=template&id=11a62e72&scoped=true"
import script from "./edit_approve.vue?vue&type=script&lang=js"
export * from "./edit_approve.vue?vue&type=script&lang=js"

import "./edit_approve.vue?vue&type=style&index=0&id=11a62e72&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a62e72"]])

export default __exports__